/**
 * Hero slideshow videos.
 *
 * A slide can carry both a landscape (desktop) and a portrait (mobile) cut.
 * Both <video> elements are in the DOM and CSS hides the one that doesn't
 * belong to the current breakpoint — but a display:none video still fetches
 * its source, so the markup ships without one. This attaches the source to
 * the video the breakpoint actually shows, and only that one.
 *
 * If this never runs (JS off, script blocked), every video stays sourceless
 * and the poster — the slide's still photo — is what visitors see.
 *
 * The 576px breakpoint mirrors .desktop_video / .mobile_video in
 * section-slideshow.css; keep the two in sync.
 */
(function () {
  var desktop = window.matchMedia('(min-width: 576px)');

  function activate(video) {
    if (video.dataset.heroLoaded) return;
    video.dataset.heroLoaded = '1';

    var source = document.createElement('source');
    source.src = video.dataset.heroSrc;
    source.type = video.dataset.heroType;
    video.appendChild(source);
    video.load();

    var playing = video.play();
    if (playing && playing.catch) {
      // Autoplay refused (data saver, low power mode…): poster stays up.
      playing.catch(function () {});
    }
  }

  function sync() {
    var videos = document.querySelectorAll(
      '.slideshow__video video[data-hero-src]'
    );
    Array.prototype.forEach.call(videos, function (video) {
      var isDesktopCut = video.classList.contains('desktop_video');
      var isMobileCut = video.classList.contains('mobile_video');
      if (isDesktopCut && !desktop.matches) return;
      if (isMobileCut && desktop.matches) return;
      activate(video);
    });
  }

  sync();

  // Crossing the breakpoint reveals a video that was never sourced.
  if (desktop.addEventListener) {
    desktop.addEventListener('change', sync);
  } else if (desktop.addListener) {
    desktop.addListener(sync);
  }
})();
